module.exports = __webpack_public_path__ + "media/images/schedule-90b84f18781403ec5e56826eb86020d2.svg";